import React, { useState } from "react";
import "../assets/css/faq.css";

const FaqItem = ({ item, index }) => {
  const [selected, setSelected] = useState(null);

  const handleSelection = (i) => {
    setSelected(i === selected ? null : i);
  };
  return (
    <>
      <div className={`faq-wrapper ${selected === index ? "open" : ""}`}>
        <div className="title" onClick={() => handleSelection(index)}>
          <h3>{item.question}</h3>
          <span className={`faq-plus ${selected === index ? "turn" : ""}`}>+</span>
        </div>
        <div className="answer">{item.answer}</div>
      </div>
    </>
  );
};

export default FaqItem;
